import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';

const Done = ({ value, message, onNext }) => {
  const [isSaving, setIsSaving] = useState(false);

  const onDone = async (value) => {
    setIsSaving(true);
    await onNext(value);
    setIsSaving(false);
  }

  return (
    <div className='step'>
      <div>{message}</div>
      <div>{`Your list is ready!`}</div>
      <div className='buttons'>
        <button disabled={isSaving} className='primary' onClick={() => onDone(value)}>
          {
            isSaving ? <FontAwesomeIcon icon={faRefresh} spin />
              : <span>Done</span>
          }
        </button>
      </div>
    </div>
  )
}

export default Done;